import { useMemo } from 'react';
import { useDomainVersion } from '~/hooks/domain/useDomainVersion';
import { useSelectedPrimaryImage } from '~/hooks/image/useSelectedImages';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import {
    RegistrationTargetImage,
    targetImageFromImage,
} from './registrationTargetImage';

/** Every loaded image of the selected patient except the primary image, as propagation targets. */
export function useLoadedTargetImages(): RegistrationTargetImage[] {
    const patient = useSelectedPatient();
    const primaryImage = useSelectedPrimaryImage();
    const domainVersion = useDomainVersion();

    return useMemo(
        () =>
            (patient?.images ?? [])
                .filter((image) => image !== primaryImage)
                .map(targetImageFromImage),
        // domainVersion is the invalidation trigger for in-place aggregate
        // mutations, which change no value React can otherwise observe.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [patient, primaryImage, domainVersion]
    );
}
